export default {
  overrideRequest: function (axiosConfig) {

  },
  addfavorite: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  removefavorite: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  }
}



// WEBPACK FOOTER //
// ./src/library/rpcService/api/services/Gap.js